import { tryExitSxSEditMode } from '../actions/publicLazyActions';
import { EditMode } from '../store/schema/SxSEditState';
import getOrCreateSxSStoreData from '../store/Store';
import { EnteredEditModeEvent, ExitedEditModeEvent } from '../utils/eventNames';

export default async function canCloseSxS(sxsId: string): Promise<boolean> {
    const store = getOrCreateSxSStoreData(sxsId);

    // wait if in edit mode
    while (store.viewState.previewPane && store.editState.mode !== EditMode.View) {
        if (store.editState.mode === EditMode.EnteringEdit) {
            // wait for EnteredEditModeEvent
            await new Promise(resolve => {
                store.eventManager.once(EnteredEditModeEvent, () => {
                    resolve();
                });
            });
        } else {
            // Edit or Saving
            if (store.editState.mode === EditMode.Edit) {
                tryExitSxSEditMode(sxsId);
            }

            // wait for ExitedEditModeEvent
            const success = await new Promise<boolean>(resolve => {
                store.eventManager.once(ExitedEditModeEvent, success => {
                    resolve(success);
                });
            });

            return success;
        }
    }

    return true;
}
